"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("GroupsService", ["ApiService", "$rootScope", function (ApiService, $rootScope) {
  var that = this;

  var params = {
    name: "groups",
    attributesForCache: ["name", "parent", "backgroundColor", "inactive", "ccUsers"],

    formatName: function formatName(element) {
      if (element.error === 404 && !["super-admin", "super-operator", "operator", "user-admin", "hr"].includes($rootScope.$user.role)) {
        return "Masqué (hors périmètre)";
      } else if (element.error === 404) {
        return "Supprimé";
      }
      var name = "";

      if (element.inactive) {
        name += "[GROUPE DÉSACTIVÉ] ";
      }

      if (element.parent) {
        name += element.parent + " > ";
      }

      name += element.name ? element.name : "N.C.";
      return name;
    }
    //defaultOrder: {date: -1},
  };

  angular.extend(that, ApiService.getModelBis(params));

  // Fetch each time: the ordinary label cache includes all customer groups.
  that.getDamageSelectArray = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", that.customPost("selectArrayForDamage", {
              customerId: $rootScope.$selectedCustomerId
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}]);